import * as Styles from './SeminarAbout.styles';
import SeminarOverview, { SeminarOverviewType } from '../SeminarOverview';
import SeminarSpeaker, { SeminarSpeakerType } from '../SeminarSpeaker';

type SeminarAboutType = SeminarOverviewType & SeminarSpeakerType;

const SeminarAbout = (props: SeminarAboutType): JSX.Element => {
  return (
    <div>
      <Styles.AboutTab data-testid="seminar-details-about">About</Styles.AboutTab>
      <Styles.AboutBox>
        <SeminarOverview {...props} />
        <Styles.Divider />
        <SeminarSpeaker {...props} />
      </Styles.AboutBox>
    </div>
  );
};

export default SeminarAbout;
